.answer {
  border-bottom: 1px solid var(--color-muted);
  margin: 1rem 0;
  padding-bottom: 1rem;
}

.answer:last-child {
  border-bottom: none;
  margin-bottom: 1rem;
}

.content {
  align-items: center;
  display: flex;
}

.score {
  font-size: 1.75rem;
  padding: 1rem;
  width: 50%;
}

.details {
  padding: 1rem;
  width: 50%;
}
